interface Options {
  initText: string;
  reCountText: string;
  total: number;
}

const defaultOptions: Options = {
  initText: '获取验证码',
  reCountText: '重新获取',
  total: 60,
};

export default class SmsCountdown {
  public constructor(options?: Options) {
    this.options = { ...options, ...defaultOptions };
  }

  private timer: NodeJS.Timer | null = null;

  private _value = -1;

  private options: Options;

  get value(): number {
    return this._value;
  }

  get text(): string {
    let text = '';
    if (this.isInit) {
      text = this.options.initText;
    } else if (this.isEnd) {
      text = this.options.reCountText;
    } else {
      text = `${this.options.reCountText}${this._value}s`;
    }
    return text;
  }

  // resend 重新发送 场景, 用户看到短信验证码弹窗时，短信验证码已发送
  get reSend(): string {
    let text = '';
    if (this.isInit) {
      text = this.options.reCountText;
    } else if (this.isEnd) {
      text = this.options.reCountText;
    } else {
      text = `${this.options.reCountText}${this._value}s`;
    }
    return text;
  }

  // 临时方案-- 还款单独设置倒计时
  get btnText(): string {
    let text = '';
    if (this.isInit || this.isEnd) {
      text = '确认还款';
    } else {
      text = `${this._value}s`;
    }
    return text;
  }

  get isRunning(): boolean {
    return this._value > 0;
  }

  get isInit(): boolean {
    return this._value === -1;
  }

  get isEnd(): boolean {
    return this._value === -2;
  }

  // 开始倒计时到结束
  start(): void {
    if (this._value >= 0) {
      return;
    }
    this._value = this.options.total;
    this.timer = setInterval(() => {
      this._value -= 1;
      if (this._value === 0) {
        this._value = -2;

        if (this.timer) {
          clearInterval(this.timer);
        }
      }
    }, 1000);
  }

  reset(): void {
    this._value = -1;

    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
